import React from "react";
import { Select } from "antd";

const SelectInputWrapper = ({ wrapClassName, wrapID, ...otherProps }) => {
  return (
    <div className={wrapClassName} id={wrapID}>
      <Select {...otherProps} />
    </div>
  );
};

export default SelectInputWrapper;
